<template>
  <page-layout class="article_editor">

    <!-- 에디터 소개 -->
    <div class="inner">
      <div class="editor_info">
        <p class="img"><img :src="getFileExist(getCurrentEditor.prof_img)"></p>
        <p class="name">{{getCurrentEditor.nick}}</p>
        <p class="position">{{getCurrentEditor.position}}</p>
        <p class="email">{{getCurrentEditor.email}}</p>
      </div>
    </div>

    <sub-page-layout>

      <div class="title">
        <h3>{{getEditorPosts.total}} Articles</h3>
        <drop-down :data="sortOptions" key-name="key" value-name="value" :default-key="sortKey" :action="clickDrowdownRow"></drop-down>
      </div>

      <ul class="lst" id="lst" v-if="getEditorPosts">
        <li v-for="(post, index) in queryData" :key="index" :class="{ 'has_banner': showSubMiddleBanner(index) }">

          <div v-if="showSubMiddleBanner(index)" class="banner">
            <display-container :section="313" empty-bg-color="transparent">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
              </template>
            </display-container>
            <!--<ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-5310971739125617"
               data-ad-slot="1019921057"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>-->
            </div>

          <post-container :post="post"></post-container>
        </li>
      </ul>

      <a class="lst_no" v-if="!getEditorPosts.loading && getEditorPosts.total < 1">Did not match any articles</a>
      <a class="lst_more" :disabled="getEditorPosts.loading" v-if="!isEditorPostsFinish && getEditorPosts.total > 0" @click="getMoreEditorPosts()">Load More Articles</a>

    </sub-page-layout>
  </page-layout>
</template>

<script>
  import {Loading, Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import SubPageLayout from '../layouts/SubPageLayout'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import {mapGetters} from 'vuex'
  const baseAction = '/members'
  export default {
    name: 'ArticleEditor',
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getCurrentEditor.nick} 에디터, ${this.getEditorPosts.total}개 아티클`,
        meta: [
          {vmid: 'description', name: 'description', content: `${this.getCurrentEditor.slogan}`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', propert: 'og:title', content: `${this.getCurrentEditor.nick} 에디터, ${this.getEditorPosts.total}개 아티클 | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `${this.getCurrentEditor.slogan}`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        baseAction: baseAction,
        sortKey: 'pub_dt',
        sortOptions: [
          {key: 'pub_dt', value: '최신순'},
          {key: 'view_cnt', value: '인기순'}
        ]
      }
    },
    created() {
      this.getRouteQuery()
    },
    activated () {
      this.$store.dispatch('callEditorPosts')
      this.$store.dispatch('setCurrentEditor')
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getEditorPosts',
        'isEditorPostsFinish',
        'getCurrentEditor',
        'isExistDisplaySubMiddleBanner'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      queryData () {
        return this.getEditorPosts.data
          .sort((a, b) => a['idx'] > b['idx'] ? 1 : -1)
          .sort((a, b) => a[this.sortKey] < b[this.sortKey] ? 1 : -1)
      }
    },
    methods: {
      ...CommonMethods,
      getRouteQuery() {
        const query = this.$route.query
        const rtn = this.sortOptions.find(row => row.key === query.sort)
        if (rtn) this.sortKey = query.sort
      },
      getMoreEditorPosts () {
        this.$store.dispatch('loadEditorPosts')
      },
      clickDrowdownRow (row) {
        this.sortKey = row.key
        this.$router.replace({query: {sort: row.key}})
      },
      showSubMiddleBanner (index) {
        return index > 0 && index%6===0 && this.isMobile && this.isExistDisplaySubMiddleBanner
      }
    },
  }
</script>

<style scoped>
  .editor_info {
    display: block;
    text-align: center;
    /*border-bottom: 1px solid #000;*/
    padding-bottom: 35px;
  }
  .editor_info p {
    font-size: 16px;
    font-weight: 500;
  }
  .editor_info .img img {
    width: 100px;
    height: 100px;
    border-radius: 100%;
  }
  .editor_info .name {
    font-size: 30px;
    font-weight: 900;
    margin-top: 15px;
  }
  .editor_info .position {
    margin: 8px 0;
  }
  .editor_info .email {
    color: #888;
  }
</style>
